@if (visible) {
  <div class="qa-banner" role="status">
    <strong>QA ENVIRONMENT</strong>
    <span class="qa-banner-detail">Test data only. Nothing here affects live merchants or payments.</span>
  </div>
}
